 
 // Gift Wrap
  const giftBagsTrigger = document.querySelector('#gift-wrapping')
  const giftBagsTextbox = document.querySelector('.gift-wrap--message')
  let checked = JSON.parse(localStorage.getItem(giftBagsTrigger.id))

  giftBagsTextbox.style.display = 'none'
  let cartItems;
  const customFetch = async (url, body) => {
    await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    window.CartSubscriber.update()
  }

  const updateCheck = () => {
    cartItems = window.CartSubscriber.cart
    const checkCartItems = items => items.id === 40915472023604
    checked = cartItems.items.some(checkCartItems)
    giftBagsTrigger.checked = checked
    giftBagsTextbox.style.display = giftBagsTrigger.checked ? 'block' : 'none'
  }

  updateCheck()
  window.CartSubscriber.on('updated', updateCheck)
  

  giftBagsTrigger.addEventListener('click', () => {
    if(giftBagsTrigger.checked) {
      localStorage.setItem(giftBagsTrigger.id, giftBagsTrigger.checked)
      customFetch('cart/add.js',{
        'items': [{
        'id': 40915472023604,
        'quantity': 1
        }]
      })
      .then(() => {
        console.log("add")
        window.CartSubscriber.updateWithUI()
      })
      .catch((error) => console.log(error))

    } 

    if(!giftBagsTrigger.checked) {
      localStorage.setItem(giftBagsTrigger.id, giftBagsTrigger.checked)
      customFetch('cart/update.js',{
        updates: {
          40915472023604: 0,
        }
      })
      .then(() => {
        console.log("update")
        window.CartSubscriber.updateWithUI()
      })
      .catch((error) => console.log(error))
    }

  })